import TemplateSelector from "pages/dashboard/schedule/components/templateSelector";
import { useEffect, useState } from "react";
import { showToast } from "ui/components/common";
import { LoadingOutlined } from "@ant-design/icons";
import AlgoTabSelection from "./algoTabSelection";
import { getTemplateList } from "pages/dashboard/virtualGuardTemplate/service";
export default function PresetAlgorithm({
  checkedAlgo,
  onCheckAlgo,
  loading,
  onSelectAlgoTemplate,
}) {
  const [scheduleTemplates, setScheduleTemplates] = useState([]);
  useEffect(() => {
    getTemplateList("algo").then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to fetch algorithm templates");
      } else {
        setScheduleTemplates(
          data.data?.data?.map((template) => ({
            label: template.name,
            algos: template.algos,
            key: template.id,
          })),
        );
      }
    });
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flex: "1",
        position: "relative",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "99%",
          justifyContent: "space-between",
        }}
      >
        <span style={{ fontSize: "20px", fontWeight: "600" }}>
          Algorithm
          <span style={{ marginLeft: "12px" }}>
            <TemplateSelector
              templateList={scheduleTemplates}
              onApply={(e) => {
                onSelectAlgoTemplate(e.item.props.algos);
              }}
            />
          </span>
        </span>
        <span style={{ textWrap: "nowrap" }}>
          {"Selected count: " + checkedAlgo.length}
        </span>
      </div>
      <div style={{ width: "100%", marginTop: "4px" }}>
        <AlgoTabSelection checkedAlgo={checkedAlgo} onCheckAlgo={onCheckAlgo} />
      </div>
    </div>
  );
}
